<template>
  <div
    :class="{hideSidebar:!sidebarStatus}"
    class="app-wrapper">
    <div class="sidebar-wrapper">
      <div class="sidebar-header">
        <div class="animate">
          <icon-svg
            class="logo"
            icon-class="logo"/>
          <span>哈啰出行</span>
        </div>
      </div>
      <sidebar class="sidebar-container"/>
    </div>
    <div class="main-container">
      <navbar/>
      <app-main/>
    </div>
  </div>
</template>


<script>
import { Navbar, Sidebar, AppMain } from '@/views/layout';
import store from '../../store/sideBar';

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  subscriptions() {
    return {
      sidebarStatus: store.state
        .map(val => val.open)
    };
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  width: 100%;
  &.hideSidebar {
    .sidebar-wrapper {
      transform: translate(-160px, 0);
      .animate{
        animation: 'up' 1s ease forwards;
      }
      .sidebar-container {
        transform: translate(152px, 0);
      }
      &:hover {
        transform: translate(0, 0);
        .sidebar-container {
          transform: translate(0, 0);
        }
        .animate{
          animation: 'down' 1s ease forwards;
        }
      }
    }
    .main-container {
      margin-left: 40px;
    }
  }
  .sidebar-header {
    text-align: center;
    line-height: 50px;
    background:url('../../assets/jianbianse.png');
    color: white;
    font-size: 20px;
    font-weight: bold;
    position: relative;
  }
  .sidebar-wrapper {
    width: 200px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
    overflow: hidden;
    transition: all 0.28s ease-out;
  }
  .sidebar-container {
    transition: all 0.28s ease-out;
    position: absolute;
    top: 50px;
    bottom: 0;
    left: 0;
    right: -17px;
    overflow-y: scroll;
  }
  .main-container {
    transition: all 0.28s ease-out;
    margin-left: 200px;
  }
}
.logo{
  font-size:24px;
  opacity: 1;
  margin-left: 2px;
}

@keyframes down {
  0%{
    transform: translate(123px,0)
  }
  100%{
    transform: translate(0,0)
  }
}
@keyframes up {
  0%{
    transform: translate(0,0)
  }
  100%{
    transform: translate(123px,0)
  }
}
.animate{
  animation: 'down' 1s ease  forwards;
  span{
    transform: translateY(-2px);
  }
}
.main-container{
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue?4308d480